package top.wcpe.allincore.dsl.compiler.semantic.`native`.methods

import top.wcpe.allincore.dsl.compiler.semantic.`native`.MethodDescriptor

/**
 * 内置 object `vanilla` 的方法占位集合。
 *
 * 当前 DSL 中尚未定义 vanilla 宿主 object 的具体方法调用，
 * 此处保留空 method map 作为描述符占位。
 * Stage TBD 时由具体业务方法填充。
 */
val VanillaApiMethodMap: Map<String, MethodDescriptor> = emptyMap()
